import React from "react";
import context from "./../../lib/context.js";
import ReportsItem from "./reports-item.jsx";
import ReportsContent from "./reports-content.jsx";
import ajax from "./../../lib/ajax.js";
import {browserHistory} from 'react-router';

export default class ReportsMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: ""
        };

        this.loadViewModel = this.loadViewModel.bind(this);
    }

    handleChange(newTitle) {
        if (this.state.title != newTitle) {
            this.setState({
                title: newTitle
            });
        }
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(`report-menu/${this.props.role}`)
            .then(function (res) {
                if (self.props.role == 'payroll-admin' && res.data.companies.length == 0) {

                    let url = context.routeUrl("home?msg=Missing%20assigned%20company%20for%20Payroll%20Admin.%20Please%20contact%20Help%20desk");
                    browserHistory.push(url);
                }

                self.setState({
                    title: res.data.reportsWelcomeLabel,
                    unapprovedHoursLabel: res.data.unapprovedHoursLabel,
                    dailyActivityLabel: res.data.dailyActivityLabel,
                    missingHoursLabel: res.data.missingHoursLabel,
                    timecardDetailLabel: res.data.timecardDetailLabel,
                    taskReportLabel: res.data.taskReportLabel,
                    homeLabel: res.data.homeLabel,
                    covidAssessmentLabel: res.data.covidAssessmentLabel,
                    employeePtoBalanceLabel: res.data.employeePtoBalanceLabel,
                    workLocationLabel: res.data.workLocationLabel
                });

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    render() {

        var items = [
                {
                    "text": this.state.homeLabel,
                    "url": context.routeUrl("home")
                },
                {
                    "text": this.state.unapprovedHoursLabel,
                    "url": "#"
                },
                {
                    "text": this.state.dailyActivityLabel,
                    "url": "#"
                },
                {
                    "text": this.state.missingHoursLabel,
                    "url": "#"
                },
                {
                    "text": this.state.timecardDetailLabel,
                    "url": "#"
                },
                {
                    "text": this.state.taskReportLabel,
                    "url": "#"
                },
                {
                    "text": this.state.covidAssessmentLabel,
                    "url": "#"
                },
                {
                    "text": this.state.employeePtoBalanceLabel,
                    "url": "#"
                },
                {
                    "text": this.state.workLocationLabel,
                    "url": "#"
                }
            ];  

        var itemsToRender = items.map(function (item, i) {
            return <ReportsItem key={i} text={item.text} url={item.url} parameters={item.parameters} onClick={this.handleChange.bind(this)} />
        }, this);

        return (
            <div className="container">
                <br /><br />
                <div className="row">
                    <h2 className="text-center ap-title">{this.state.title}</h2>
                </div>
                <br /><br />
                <div className="row">
                    <div className="col-md-2">                    
                        <ul className="nav navbar-nav" style={{ float: "none"}}>
                            {itemsToRender}
                        </ul>
                    </div>
                    <div className="col-md-10 col-lg-10">
                        <div className="row col-md-12 col-lg-12">
                        </div>
                        <div className="row col-md-12 col-lg-12">
                            <ReportsContent title={this.state.title} role={this.props.role} pdfViewerRoute={this.props.pdfViewerRoute} />
                        </div>
                    </div>
                </div>
                <br /><br />
            </div>
        );
    }
}